import * as angular from "angular";

export class LeaderBoardService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/organisation/leaderboard";
    }

    getResults(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/results", { params: data });
    }

    getRank(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/rank", { params: data });
    }

    getDivisions(data?: any): Promise<object> {
        return this.$http.get(this.v2Root + "/divisions", { params: data });
    }
}

angular.module("vcServices").service("LeaderBoardService", LeaderBoardService);
